import { refreshAccessToken } from "@/redux/features/auth-thunk";
import { store } from "@/redux/store";
import Cookies from "js-cookie";
import axios from "axios";


const getAuthToken = () =>
  Cookies.get("super_admin_access_token") || Cookies.get("access_token");

const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
});

apiClient.interceptors.request.use(
  (config: any) => {
    const token = getAuthToken();
    if (token && !config.headers?.Authorization) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (config.url === "/api/auth/login") {
      config.headers = {
        ...config.headers,
        "Content-Type": "application/x-www-form-urlencoded",
        accept: "application/json",
      };
    } else if (config.url === "/api/auth/refresh-token") {
      delete config.headers["Authorization"];
    } else if (config.data instanceof FormData) {
      // For FormData, don't set Content-Type - let the browser set it with boundary
      config.headers = {
        ...config.headers,
        // Don't set Content-Type for FormData - browser will set it automatically
      };
    } else {
      config.headers = {
        ...config.headers,
        "Content-Type": "application/json",
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: any) => {
    const oldToken = getAuthToken();

    const originalRequest = error.config;
    if (!originalRequest) {
      return Promise.reject(error);
    }

    const status = error.response?.status ?? error.status;
    if (oldToken && status === 401) {
      if (
        error.response?.data?.message ==
        "Your session has expired. Please log in again to continue."
      ) {
        try {
          const result = await store.dispatch(refreshAccessToken()).unwrap();

          if (!result || !result.access_token) {
            throw new Error("Failed to get new token");
          }

          originalRequest.headers[
            "Authorization"
          ] = `Bearer ${result.access_token}`;
          return await axios(originalRequest);
        } catch (refreshError) {
          console.error("Token refresh failed:", refreshError);

          Cookies.remove("access_token");
          Cookies.remove("refreshToken");
          Cookies.remove("super_admin_access_token");
          Cookies.remove("super_admin_refresh_token");

          localStorage.clear();
          return Promise.reject(refreshError);
        }
      } else {
        Cookies.remove("access_token");
        Cookies.remove("refreshToken");
        Cookies.remove("super_admin_access_token");
        Cookies.remove("super_admin_refresh_token");

        localStorage.clear();
      }
    }
    return Promise.reject(error);
  }
);
export default apiClient;
